import { makeAutoObservable, runInAction } from 'mobx'

import { TOAST_STRING } from '~/@common/constants/strings'
import { toastService } from '~/@common/services'
import { getGradeSubjectSemesterRevisionToKor } from '~/@common/utils/grade'

import { homeApi } from '../@common/api'
import type { AssignedChallenge, RecentStudyItem } from '../@common/response'

class AssignedLearningService {
  assignedChallenge: AssignedChallenge | null = null
  private assignedWorksheetList: RecentStudyItem[] = []

  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  get assignedChallengeConceptChipCount(): { 개념: number; 기본: number; 심화: number } {
    return {
      개념: this.assignedChallenge?.learningConceptChip.conceptChipA ?? 0,
      기본: this.assignedChallenge?.learningConceptChip.conceptChipB ?? 0,
      심화: this.assignedChallenge?.learningConceptChip.conceptChipC ?? 0,
    }
  }

  get assignedWorksheet(): RecentStudyItem | null {
    return this.assignedWorksheetList[0] ?? null
  }

  get isEmptyAssignedLearning(): boolean {
    return !this.assignedChallenge && !this.assignedWorksheet
  }

  get assignedChallengeInfoString() {
    return (
      this.assignedChallenge &&
      getGradeSubjectSemesterRevisionToKor({
        ...this.assignedChallenge.school,
        revision: this.assignedChallenge.revision,
      })
    )
  }

  /**
   * 챌린지 + 학습지 병렬 호출
   * 단일 loading 상태 관리
   */
  async fetchAllAssignedLearning() {
    if (this.isLoading) return

    this.isLoading = true

    try {
      const [challengeRes, worksheetRes] = await Promise.all([
        homeApi.fetchAssignedChallenge(),
        homeApi.fetchRecentStudies({
          materialViewType: 'WORKSHEET',
          lastStudentExamId: null,
          lastStudentHomeworkId: null,
          lastStudentWorkbookRevisionId: null,
          lastStudentWorksheetId: null,
          lastStudentCasAutoTestId: null,
        }),
      ])

      runInAction(() => {
        this.assignedChallenge = challengeRes
        this.assignedWorksheetList =
          worksheetRes.contents.filter((item) => item.accessModifierToStudent === 'PUBLIC') ?? []
      })
    } catch (error) {
      toastService.error(TOAST_STRING.error)
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }
}

export default AssignedLearningService
